<mat-card [class.expanded]="expanded()">
  <div class="header">
    <div class="header-title">
      <span class="title">{{ product().details.name }}</span>
      <span class="subtitle">{{ product().details.description }}</span>
    </div>

    <ui-icon-button
      buttonStyle="unthemed"
      (clicked)="expanded.set(!expanded())"
      [icon]="expanded() ? 'chevron-up' : 'chevron-down'"
      iconStyle="solid">
    </ui-icon-button>
  </div>

  <ui-expander-content [expanded]="expanded()">
    <div class="wrapper-product-lists">
      <div class="product-list">
        @for (product of bundledProducts(); track product) {
          <ui-configurable-bundle-order-card-item [bundleItem]="product"></ui-configurable-bundle-order-card-item>
        }
      </div>

      <div class="product-list">
        @for (freeProduct of bundledFreeProducts(); track freeProduct) {
          <ui-configurable-bundle-order-card-item [bundleItem]="freeProduct"></ui-configurable-bundle-order-card-item>
        }
      </div>
    </div>
  </ui-expander-content>

  <ui-configurable-bundle-order-card-footer
    class="mobile"
    (edit)="edit()"
    (remove)="remove.emit()"
    [product]="product()"
    [readonly]="readonly()"
    [isRemoveLoading]="isRemoveLoading()"
  >
  </ui-configurable-bundle-order-card-footer>
</mat-card>

<ui-configurable-bundle-order-card-footer
  class="desktop"
  (edit)="edit()"
  (remove)="remove.emit()"
  [product]="product()"
  [isRemoveLoading]="isRemoveLoading()"
  [readonly]="readonly()">
</ui-configurable-bundle-order-card-footer>
